<template>
  <div class="board">

    <div class="container">
      <img class="map-bg" src="../../../../static/img/map-bg.jpg"/>


      <div class="title">联真签约网点展示</div>

      <repair-point-list class="repair-point-list"
                         :provinceData="provinceData"
                         :list="repairPointList"
                         @clickProvince="clickProvince"
      ></repair-point-list>
      <a-map-board ref="map" class="map-board"></a-map-board>
      <repair-point-show ref="repairPointShow"></repair-point-show>
    </div>
  </div>
</template>

<script>
  import AMapBoard from './AMapBoard'
  import RepairPointList from './RepairPointList'
  import RepairPointShow from './RepairPointShow'

  export default {
    components: {AMapBoard, RepairPointList, RepairPointShow},
    data () {
      return {
        repairPointList: [],
        provinceData: []
      }
    },
    created () {

    },
    mounted () {
      this.$get('/app/repairpoint/getList').then(suc => {
        this.repairPointList = suc.data
      })

      this.$get('/app/repairpoint/getNumByProvince').then(suc => {
        this.provinceData = suc.data.sort(function (a, b) {
          return b.num - a.num
        })
      })

      setInterval(()=>{
        this.$get('/app/repairpoint/getLatest').then(suc => {
          console.log("getLatest")
          console.log(suc.data)
          if(suc.data.id>0){
            this.$refs.repairPointShow.show(suc.data)
          }
        })

        this.$get('/app/repairpoint/getNumByProvince').then(suc => {
          this.provinceData = suc.data.sort(function (a, b) {
            return b.num - a.num
          })
        })


      },5000)
    },
    methods: {
      clickProvince (province) {
        this.$refs.map.showProvince(province)
      }
    }
  }
</script>

<style scoped>
  .board {
    width: 100%;
    height: 100%;
    position: fixed;
    background: #999;
    top: 0;
    left: 0;
    z-index: 200;
  }

  .container {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .map-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    color: #00F6FF;
    font-size: 40px;
    padding-top: 10px;
  }

  .map-board {
    width: 80%;
    margin-left: 20%;
    height: 100%;
    position: absolute;
  }

  .repair-point-list {
    position: absolute;
    left: 40px;
    height: 98%;
    top: 0;
  }

</style>



// WEBPACK FOOTER //
// src/views/home/board/MapDataBoard.vue